export default "__VITE_ASSET__ub96tSa4__"